<template>
  <span>
    <a
      v-if="!bypassCode && hasBypassCodesAvailable"
      href="javascript:void(0)"
      @click="retrieveBypassCodes()"
    >retrieve bypass code</a>
    <span v-if="!hasBypassCodesAvailable">unavailable</span>
    <span
      v-if="bypassCode"
    >
      <span :class="$style.collectedOn">Collected on {{ collectedAt }}</span>
      <span v-if="bypassCode">{{ bypassCode }} </span>
    </span>
    <AlertContainer>
      <Alert
        v-if="errorText"
        type="error"
      >
        <span>{{ errorText }}</span>
      </Alert>
    </AlertContainer>
  </span>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';
import Alert from 'client/components/Alert/Alert.vue';
import AlertContainer from 'client/components/Alert/AlertContainer.vue';
import DateUtil from 'client/util/DateUtil';

const mdmSettingsModel = StoreModelMap[ItemTypeConsts.mdmSettings];
const systemModel = StoreModelMap[ItemTypeConsts.device];

export default {
  name: 'RetrieveBypassCode',

  components: {
    Alert,
    AlertContainer,
  },

  data: () => ({
    bypassCode: '',
    collectedAt: '',
    errorText: '',
    showBypassCode: false,
  }),

  computed: {
    ...mapState(systemModel, [
      'item',
    ]),

    hasBypassCodesAvailable() {
      return get(this.item, 'activationLock.hasActivationLockBypassCodes', false);
    },
  },

  mounted() {
    this.fetchMdmSettings();
  },

  methods: {
    ...mapActions(mdmSettingsModel, [
      'fetchBypassCodes',
      'fetchMdmSettings',
    ]),

    async retrieveBypassCodes() {
      try {
        const response = await this.fetchBypassCodes({ deviceId: get(this.item, 'mdm.internal.deviceId') });
        const { collectedAt, bypassCode } = response[0];

        this.collectedAt = DateUtil.formatDate(collectedAt);
        this.bypassCode = bypassCode;
      } catch {
        this.errorText = 'Bypass Code unable to be retrieved. Please try again later';
      }
    },
  },
};
</script>
<style module>

.collectedOn {
  font-style: italic;
  padding-right: 1em;
}

</style>
